import { getFetch } from '@legacy/utils/fetcher';
import { useQuery } from '@tanstack/react-query';
import { concatQueries } from '@legacy/utils/url';
import { IAddedValuePerMonth } from '../../types/addedValuePerMonth';

const GET_ADDED_VALUE_PER_MONTH_WIDGET_URL_PATH =
  '/api/v2/insights-service/hour-kpi-per-month';
const GET_ADDED_VALUE_PER_MONTH_WIDGET_MSW_STATUS_KEY =
  'getAddedValuePerMonthAPI';

const GET_ADDED_VALUE_PER_MONTH_WIDGET_KEY =
  'GET_ADDED_VALUE_PER_MONTH_WIDGET_KEY';

const getAddedValuePerMonthReportingWidget = (
  filterId: string,
): Promise<IAddedValuePerMonth> =>
  getFetch({
    path: `${GET_ADDED_VALUE_PER_MONTH_WIDGET_URL_PATH}${concatQueries([
      { param: 'filter', value: filterId },
    ])}`,
    key: GET_ADDED_VALUE_PER_MONTH_WIDGET_MSW_STATUS_KEY,
  });

export const useGetAddedValuePerMonthReportingWidget = (filterId: string) => {
  const { data, ...restProps } = useQuery({
    queryKey: [GET_ADDED_VALUE_PER_MONTH_WIDGET_KEY, filterId],

    queryFn: () => getAddedValuePerMonthReportingWidget(filterId),
  });

  if (data?.properties) {
    const { hourKPIPerMonths } = data.properties.data;
    return {
      widgetName: data.properties.type,
      widgetData: hourKPIPerMonths,
      currencyAbb: data.properties.baseCurrencyAbb,
      isEmpty: hourKPIPerMonths.length <= 0,
      ...restProps,
    };
  }

  return {
    widgetName: '',
    widgetData: [],
    currencyAbb: '',
    isEmpty: true,
    ...restProps,
  };
};
